import { combineReducers } from 'redux';
import settings from './settings/reducer';
import menu from './menu/reducer';
import authUser from './auth/reducer';
import credit from './credit/reducer';
import globals from './globals/reducer';
import client from './client/reducer';
import wizard from './wizard/reducer';
import dependencies from './dependencies/reducer';
import errors from './errors/reducer';
import codebtor from './codebtor/reducer';
import validations from './validations/reducer';
import general from './general/reducer';
import creditEmployees from './creditEmployees/reducer';
import modals from './modals/reducer';
import warranty from './waranty/reducer';
import financialSolution from './financialSolution/reducer';

import { LOGOUT_USER } from './actions';

const reducersList = combineReducers({
    menu,
    settings,
    authUser,
    credit,
    globals,
    client,
    wizard,
    errors,
    dependencies,
    codebtor,
    validations,
    general,
    creditEmployees,
    modals,
    warranty,
    financialSolution,
});

const reducers = (state, action) => {
    // Clear all data in redux store to initial.
    if (action.type === LOGOUT_USER) state = undefined;
    return reducersList(state, action);
};

export default reducers;
